import { SubmissionPayload } from "@/store/actions";
import axiosInstance from "@/services/http/http-common";

export class FormService {
  public async postValues(payload: SubmissionPayload): Promise<void> {
    await axiosInstance({
      method: "post",
      url: "/form/allgemein",
      data: payload,
    });
  }
}
